var map = {
	"./back.svg": "ccfe",
	"./check.svg": "f222",
	"./circular-flags/br.svg": "eb23",
	"./circular-flags/de.svg": "f2ab",
	"./circular-flags/en.svg": "1aad",
	"./circular-flags/es.svg": "7bc4",
	"./circular-flags/fr.svg": "0e0c",
	"./circular-flags/hi.svg": "5c95",
	"./circular-flags/it.svg": "b9b0",
	"./circular-flags/ja.svg": "be8f",
	"./circular-flags/km.svg": "20f3",
	"./circular-flags/my.svg": "b57e",
	"./circular-flags/nocountry.svg": "0f9f",
	"./circular-flags/ru.svg": "6acd",
	"./circular-flags/sa.svg": "aad0",
	"./circular-flags/sk.svg": "9067",
	"./circular-flags/sw.svg": "903b",
	"./circular-flags/tr.svg": "9e91",
	"./circular-flags/ur.svg": "fa44",
	"./circular-flags/vi.svg": "7c1f",
	"./circular-flags/zh.svg": "06eb",
	"./create.svg": "cfb8",
	"./dashboard-icons/account-icon.svg": "0d8b",
	"./dashboard-icons/account-statement.svg": "bf4d",
	"./dashboard-icons/affiliate-programme.svg": "8941",
	"./dashboard-icons/deposit.svg": "5ef2",
	"./dashboard-icons/dots.svg": "dbb1",
	"./dashboard-icons/education.svg": "07db",
	"./dashboard-icons/partner-program.svg": "7f85",
	"./dashboard-icons/personal-details.svg": "a645",
	"./dashboard-icons/play.svg": "8fa8",
	"./dashboard-icons/trading.svg": "31e0",
	"./dashboard-icons/transfer.svg": "10ea",
	"./dashboard-icons/upload-documents.svg": "4868",
	"./dashboard-icons/user-profile.svg": "2fee",
	"./dashboard-icons/wallet-left-dark.svg": "8fa9",
	"./dashboard-icons/wallet-left.svg": "dffa",
	"./dashboard-icons/wallet.svg": "6f5f",
	"./dashboard-icons/webtrader.svg": "7a00",
	"./dashboard-icons/withdrawal.svg": "4c99",
	"./demo-account.svg": "bd62",
	"./download-icons/apple-app-store.svg": "249a",
	"./download-icons/google-play-store.svg": "75ff",
	"./export.svg": "b7f9",
	"./eye.svg": "83a4",
	"./eye_opened.svg": "05ce",
	"./file-text.svg": "bd71",
	"./gift.svg": "14a1",
	"./green-check.svg": "4052",
	"./icons/account-statement-small.svg": "8ace",
	"./icons/arrow-right.svg": "cd8c",
	"./icons/arrow.svg": "21e2",
	"./icons/change-info-small.svg": "9411",
	"./icons/check-white.svg": "5131",
	"./icons/coins-exchange.svg": "f4d2",
	"./icons/copy.svg": "8aac",
	"./icons/default-avatar.svg": "af68",
	"./icons/dropdown.svg": "6d05",
	"./icons/graph.svg": "07ee",
	"./icons/hidden-icon.svg": "4bf0",
	"./icons/loader.svg": "04ff",
	"./icons/pending-2.svg": "6b1e",
	"./icons/pending-withdrawal.svg": "c190",
	"./icons/pending.svg": "e25a",
	"./icons/quote-icon.svg": "9e47",
	"./icons/referral-link-small.svg": "f91f",
	"./icons/referral-link-svg.svg": "7450",
	"./icons/visible-icon.svg": "ab89",
	"./icons/wallet.svg": "4f4a",
	"./icons/warning-icon.svg": "209f",
	"./icons/warning.svg": "daa9",
	"./lines.svg": "6f9c",
	"./logo/the4xio-logo.svg": "6da8",
	"./logo/wintrado-black.svg": "b869",
	"./logout.svg": "309a",
	"./payment-icons/advancedcash.svg": "dcc4",
	"./payment-icons/bank-transfer.svg": "4ac5",
	"./payment-icons/bitcoin-label-logo.svg": "fe29",
	"./payment-icons/cards.svg": "c230",
	"./payment-icons/cards_crypto.svg": "738b",
	"./payment-icons/crypto.svg": "2698",
	"./payment-icons/gate2pay.svg": "7cb1",
	"./payment-icons/generic-withdrawal.svg": "aed3",
	"./payment-icons/m-pesa-logo.svg": "1ef8",
	"./payment-icons/monopoly.svg": "f381",
	"./payment-icons/neteller.svg": "9bea",
	"./payment-icons/oxxo.svg": "64ed",
	"./payment-icons/pago-efectivo-2020.svg": "078d",
	"./payment-icons/payasia_vnd.svg": "1597",
	"./payment-icons/paysafecard.svg": "ba83",
	"./payment-icons/skrill.svg": "67ae",
	"./payment-icons/sticpay.svg": "0c3d",
	"./pending-circle.svg": "9b9d",
	"./real-account.svg": "a0d9",
	"./revoked-circle.svg": "94cc",
	"./yellow-pending-circle.svg": "0d92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";